<template>
  <div>
    <div class="loader-wrapper loderhide" v-if="loading">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
    <!-- page-wrapper Start-->
    <div v-else class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo pt-0">
                  <img
                    class="img-fluid for-light"
                    :src="logo"
                    style="max-width:250px"
                    alt="looginpage"
                  />
                  <img
                    class="img-fluid for-dark"
                    :src="logo"
                    style="max-width:250px"
                    alt="looginpage"
                  />
                </a>
              </div>
              <div class="login-main">
                <b-card>
                  <b-card-text>
                        <form class="theme-form" @submit.prevent="handleLogin">
                          <h4>Login Area</h4>
                          <p>{{ $t('deskripsi_login') }}</p>
                          <div class="form-group">
                            <label for="username">Corporate Email Address</label>
                            <input
                              type="text"
                              v-model="username"
                              name="email"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && !username }"
                            />
                            <div
                              v-show="submitted && !username"
                              class="invalid-feedback"
                            >
                              Username is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                              type="password"
                              v-model="password"
                              name="password"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && !password,
                              }"
                            />
                            <div
                              v-show="submitted && !password"
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                          </div>
                          <div class="form-group mt-3 mb-0">
                            <button
                              class="btn btn-primary btn-block"
                              :disabled="loggingIn"
                            >
                              Login
                            </button>
                          </div>
                          <p class="mt-4 mb-0">
                            {{ $t('tidak_memiliki_akun') }} ?
                            <router-link
                              class="ml-2"
                              tag="a"
                              to="/auth/register"
                            >
                              {{ $t('buat_account') }}
                            </router-link>
                          </p>
                        </form>
                      </b-card-text>
                </b-card>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->
  </div>
</template>
<script>
  export default {
    data(){
      return {
        logo : localStorage.getItem('logo'),
        username : '',
        password : '',
        submitted: false,
        loading: true
      };
    },
    computed:{
      loggingIn() {
        return this.$store.state.authentication.status.loggingIn;
      },
    },
    created(){
      this.getColor();
      let user = JSON.parse(localStorage.getItem('user'));
      if(user){
        if (user.roles === 'ADMIN') {
        this.$router.push({ path: '/dashboard/admin' });
        }else if(user.roles === 'CANDIDATE'){
          this.$router.push({ path: '/dashboard/candidate' });
        }
      }
      
    },
    methods: {
      handleLogin(){
        this.$store.dispatch('authentication/login', {
          email: this.username,
          password: this.password,
        });
      },
      async getColor(){
        await this.$store.dispatch('match_scoring/getColor', {
          code: process.env.VUE_APP_CODE
        }).then(res => {
          let data = res.data;
          let primary = data.primary_color;
          let secondary = data.secondray_color;
          this.$store.dispatch('layout/setColorScheme', { primary, secondary });
          localStorage.setItem('logo', data.logo_url);
          localStorage.setItem('due_date', data.due_date);
          if (!localStorage.getItem('currentLanguage')) {
            localStorage.setItem('currentLanguage', data.language);
            window.location.reload();
          }




          this.logo = data.logo_url;
          this.loading = false;
        });


      },
      toshButton(){
        this.$notify({
          group: 'toast',
          type: 'success',
          text: 'Berhasil Notif'
        });
      }
    }
  };
</script>